jQuery(function ($) {
	let sliderNews = $('.js-slider-news');
	if (sliderNews) {
		sliderNews.on('beforeChange', function(e, slick, currentSlide, nextSlide) {
			var $animatingElements = $('div.slick-slide[data-slick-index="' + nextSlide + '"]').find('[data-animation]');
			slideanimate($animatingElements);
		});
		sliderNews.slick({
			dots: false,
			appendArrows: $('.slider__btns'),
			prevArrow: '<button class="slick-prev" aria-label="Previous" type="button" style=""><svg class="svg-icon" width="8" height="14"><use xlink:href="#arrow-left"></use></svg></button>',
			nextArrow: '<button class="slick-next" aria-label="Next" type="button" style=""><svg class="svg-icon" width="8" height="14"><use xlink:href="#arrow-right"></use></svg></button>',
			slidesToShow: 1,
			fade: true,
			slidesToScroll: 1
		})
		function slideanimate(elements) {
			var animationEndEvents = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
			elements.each(function() {
				var $this = $(this);
				var $animationDelay = $this.data('delay');
				var $animationType = 'animated ' + $this.data('animation');
				$this.css({
					'animation-delay': $animationDelay,
					'-webkit-animation-delay': $animationDelay
				});
				$this.addClass($animationType).one(animationEndEvents, function() {
					$this.removeClass($animationType);
				});
			});
		}


	}
	let sliderPost = $('.js-slider-post');
	if (sliderPost) {
		sliderPost.slick({
			dots: false,
			appendArrows: $('.slider__btns'),
			prevArrow: '<button class="slick-prev" aria-label="Previous" type="button" style=""><svg class="svg-icon" width="8" height="14"><use xlink:href="#arrow-left"></use></svg></button>',
			nextArrow: '<button class="slick-next" aria-label="Next" type="button" style=""><svg class="svg-icon" width="8" height="14"><use xlink:href="#arrow-right"></use></svg></button>',
			slidesToShow: 3,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 1023,
					settings: {
						slidesToShow: 2,
						centerMode: true
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1,
						centerMode: true
					}
				}
			]
		});
	}
	let slidersMerch = $('.js-slider-merch');
	if (slidersMerch) {
		slidersMerch.each((i,e) => {
			$(e).slick({
				dots: false,
				appendArrows: $(e).next('.slider__btns'),
				prevArrow: '<button class="slick-prev" aria-label="Previous" type="button" style=""><svg class="svg-icon" width="8" height="14"><use xlink:href="#arrow-left"></use></svg></button>',
				nextArrow: '<button class="slick-next" aria-label="Next" type="button" style=""><svg class="svg-icon" width="8" height="14"><use xlink:href="#arrow-right"></use></svg></button>',
				slidesToShow: 1,
				fade: true,
				slidesToScroll: 1
			})
		}
		)
	}
});
